import { ShieldAlert } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ApprovalData {
  message: string;
  action?: string;
  details?: string;
}

interface ApprovalWidgetProps {
  data: ApprovalData;
  onAction?: (actionId: string) => void;
}

/**
 * Confirmation prompt for destructive or high-impact actions.
 * Shows a warning-styled card with approve/deny buttons.
 */
export function ApprovalWidget({ data, onAction }: ApprovalWidgetProps) {
  return (
    <Card variant="warning" padding="default" className="max-w-md animate-scale-in">
      <div className="flex gap-3">
        <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-daydra-warning/10 shrink-0">
          <ShieldAlert size={16} className="text-daydra-warning" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-daydra-text">{data.message}</p>
          {data.details && (
            <p className="text-xs text-daydra-dim mt-1">{data.details}</p>
          )}
          <div className="flex gap-2 mt-3">
            <Button
              size="sm"
              onClick={() => onAction?.("approve")}
            >
              {data.action ?? "Approve"}
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onAction?.("deny")}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
}
